import { useContext } from "@nuxtjs/composition-api";

export const EVENT_OPEN_PERSON_PROFILE = "EVENTS_GLOBAL_OPEN_PERSON_PROFILE";

export function useTrackOpenPersonProfile() {
  const { $track } = useContext();

  function trackOpenPersonProfile({
    person,
    personIndex,
    city,
    profession,
    professionTask,
  }) {
    $track.customEvent({ ecommerce: null });
    $track.customEvent({
      event: "select_item",
      city_id: city?.id,
      profession_id: profession?.id,
      profession_task_id: professionTask?.id,
      ecommerce: {
        items: [
          {
            index: personIndex,
            item_id: person.id,
            item_name: person.name,
            item_list_name: `${profession?.name} ${city?.name}`,
            item_list_id: `${city?.seoName}#${profession?.seoName}`,
          },
        ],
      },
    });
  }

  return {
    trackOpenPersonProfile,
  };
}
